// src/auth/supabase.js
// Single Supabase client instance shared by the whole app.
// The URL and anon key come from your .env.local file
// (and from Vercel Environment Variables in production).
//
// The anon key is safe to expose in the browser — RLS rules
// in the database are what actually protect user data.

import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // Helpful error during local dev if you forgot the env file.
  // In production Vercel will inject these and this branch won't trigger.
  // eslint-disable-next-line no-console
  console.warn(
    "[supabase] Missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY. " +
      "Create src/../.env.local from .env.example."
  );
}

export const supabase = createClient(url || "https://placeholder.supabase.co", anonKey || "placeholder", {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true, // handles the OAuth redirect callback
  },
});
